import React from 'react'

const NotFound = () => {
  return (
    <div className="NotFound">
    <p style={{fontSize: 25}}><b>404, page not found...</b></p>
    </div>
  )
}

export default NotFound



// WEBPACK FOOTER //
// ./src/pages/NotFound.js